import H1 from '../text/H1';
import H2 from '../text/H2';
import H3 from '../text/H3';
import H4 from '../text/H4';
import H5 from '../text/H5';
import H6 from '../text/H6';
import Link from '../text/Link';
import Paragraph from '../text/Paragraph';
import Paragraph2 from '../text/Paragraph2';
import ScalableText from './ScalableText';

export {
    H1, 
    H2, 
    H3, 
    H4, 
    H5, 
    H6, 
    Link, 
    Paragraph, 
    Paragraph2,
    ScalableText
};
